import { ThemeConfig } from 'antd';

const fonts = {
  fontFamily: 'Roboto, sans-serif'
} as ThemeConfig['token'];

const motion = {
  motionDurationFast: '200ms',
  motionDurationMid: '400ms',
  motionDurationSlow: '600ms'
} as ThemeConfig['token'];

const tokens = { ...fonts, ...motion } as ThemeConfig['token'];

export default tokens;
